export const API_ENDPOINT_KEYS = {
  getFormConfig: 'getFormConfig',
  getVptasApprovedApplicationListConfig: 'getVptasApprovedApplicationListConfig',
  getVptasPendingApplicationListConfig: 'getVptasPendingApplicationListConfig',
  getVptasNominatedPatientFormConfig: 'getVptasNominatedPatientFormConfig',
  getReferenceDataConfigAndResponse: 'getReferenceDataConfigAndResponse',
  getVictorianPatientTransportAssistanceSchemeReferenceDataConfigAndResponse: 'getVictorianPatientTransportAssistanceSchemeReferenceDataConfigAndResponse',
  getGlStringMappingConfigAndResponse: 'getGlStringMappingConfigAndResponse',
  getGlStringLookupMappingSetConfigAndResponse: 'getGlStringLookupMappingSetConfigAndResponse',
  getGlStringLookupMappingConfig: 'getGlStringLookupMappingConfig',
  getGlStringLookupMappingConfigAndResponse: 'getGlStringLookupMappingConfigAndResponse',
  getSettingConfigAndResponse: 'getSettingConfigAndResponse',
  getUserConfigAndResponse: 'getUserConfigAndResponse',
  getOrganisationConfigAndResponse: 'getOrganisationConfigAndResponse',
  getApplicationConfigAndResponse: 'getApplicationConfigAndResponse',
  getApplicationDetailCreateUpdateCarerConfigAndResponse: 'getApplicationDetailCreateUpdateCarerConfigAndResponse',
  getApplicationDetailCreateUpdatePlacementConfigAndResponse: 'getApplicationDetailCreateUpdatePlacementConfigAndResponse',
  getRuleConfigAndResponse: 'getRuleConfigAndResponse',
  getCareAllowancePlacementRuleConfigAndResponse: 'getCareAllowancePlacementRuleConfigAndResponse',
  getCareAllowanceFinancialYearListConfig: 'getCareAllowanceFinancialYearListConfig',
  getCareAllowanceCalendarYearListConfig: 'getCareAllowanceCalendarYearListConfig',
  getCareAllowanceFinancialYearConfig: 'getCareAllowanceFinancialYearConfig',
  getCareAllowanceCalendarYearConfig: 'getCareAllowanceCalendarYearConfig',
  getCareAllowanceFinancialYearConfigAndResponse: 'getCareAllowanceFinancialYearConfigAndResponse',
  getCareAllowanceCalendarYearConfigAndResponse: 'getCareAllowanceCalendarYearConfigAndResponse',
  getCareAllowanceFinancialYearConfigAndResponseWithGeneratedInvoicePeriods: 'getCareAllowanceFinancialYearConfigAndResponseWithGeneratedInvoicePeriods',
  getCareAllowanceCalendarYearConfigAndResponseWithGeneratedInvoicePeriods: 'getCareAllowanceCalendarYearConfigAndResponseWithGeneratedInvoicePeriods',
  getCareAllowanceInvoicePeriodConfigAndResponse: 'getCareAllowanceInvoicePeriodConfigAndResponse',
  getCareAllowanceApprovedRateListConfig: 'getCareAllowanceApprovedRateListConfig',
  getCareAllowancePendingRateListConfig: 'getCareAllowancePendingRateListConfig',
  getCareAllowanceRateConfigAndResponse: 'getCareAllowanceRateConfigAndResponse',
  getCareAllowancePlacementConfigAndResponse: 'getCareAllowancePlacementConfigAndResponse',
  getCareAllowanceLocalAdoptionConfigAndResponse: 'getCareAllowanceLocalAdoptionConfigAndResponse',
  getNewCareAllowanceLocalAdoptionConfigAndResponse: 'getNewCareAllowanceLocalAdoptionConfigAndResponse',
  getCareAllowancePlacementAdjustmentConfig: 'getCareAllowancePlacementAdjustmentConfig',
  getCareAllowancePlacementAdjustmentConfigAndResponse: 'getCareAllowancePlacementAdjustmentConfigAndResponse',
  getCareAllowancePlacementAdjustmentConfigAndResponseWithGeneratedLines: 'getCareAllowancePlacementAdjustmentConfigAndResponseWithGeneratedLines',
  getCareAllowancePlacementBulkAdHocInvoiceQueryConfigAndResponse: 'getCareAllowancePlacementBulkAdHocInvoiceQueryConfigAndResponse',
  getIccmsRequestProcessingScheduleConfigAndResponse: 'getIccmsRequestProcessingScheduleConfigAndResponse',
  getPersonConfigAndResponse: 'getPersonConfigAndResponse',
  getPersonListConfig: 'getPersonListConfig',
  getPersonListConfigForCarerApplicationUpdate: 'getPersonListConfigForCarerApplicationUpdate',
  getPersonListConfigForPlacementApplicationUpdate: 'getPersonListConfigForPlacementApplicationUpdate',
  getVendorConfigAndResponse: 'getVendorConfigAndResponse',
  getVmgEmailTemplateConfigAndResponse: 'getVmgEmailTemplateConfigAndResponse',
  getConcessionsApplicationDetailsConfigAndResponse: 'getConcessionsApplicationDetailsConfigAndResponse',
  getConcessionsApplicationNonMainsWaterConfigAndResponse: 'getConcessionsApplicationNonMainsWaterConfigAndResponse',
  getConcessionsApplicationNonMainsEnergyConfigAndResponse: 'getConcessionsApplicationNonMainsEnergyConfigAndResponse',
  getConcessionsApplicationNonMainsLifeSupportConfigAndResponse: 'getConcessionsApplicationNonMainsLifeSupportConfigAndResponse',
  getConcessionsApplicationNonMainsMedicalCoolingConfigAndResponse: 'getConcessionsApplicationNonMainsMedicalCoolingConfigAndResponse',
  getConcessionsApplicationEdaAndPowGoldCardMunicipalRatesConfigAndResponse: 'getConcessionsApplicationEdaAndPowGoldCardMunicipalRatesConfigAndResponse',
  getConcessionsApplicationApprovedRebateCalculationRuleListConfig: 'getConcessionsApplicationApprovedRebateCalculationRuleListConfig',
  getConcessionsApplicationPendingRebateCalculationRuleListConfig: 'getConcessionsApplicationPendingRebateCalculationRuleListConfig',
  getConcessionsRebateCalculationRuleConfigAndResponse: 'getConcessionsRebateCalculationRuleConfigAndResponse',
  getJobScheduleConfigAndResponse: 'getJobScheduleConfigAndResponse',
  getExportedInvoiceConfigAndResponse: 'getExportedInvoiceConfigAndResponse',
  getReportListConfigAndResponse: 'getReportListConfigAndResponse',
  getPersonBankDetailResponseAndConfig: 'getPersonBankDetailResponseAndConfig',
  getConcessionsApplicationBulkUploadConfigAndResponse: 'getConcessionsApplicationBulkUploadConfigAndResponse',
  getAgencyConfig: 'getAgencyConfig',
  getAgencyConfigAndResponse: 'getAgencyConfigAndResponse',
  getConcessionsApplicationBulkUploadDetailConfigAndResponse: 'getConcessionsApplicationBulkUploadDetailConfigAndResponse',
  getCareAllowancePersonConfigAndResponse: 'getCareAllowancePersonConfigAndResponse',
  getVictorianPatientTransportAssistanceSchemePendingRebateRateListConfig: 'getVictorianPatientTransportAssistanceSchemePendingRebateRateListConfig',
  getVictorianPatientTransportAssistanceSchemeApprovedRebateRateListConfig: 'getVictorianPatientTransportAssistanceSchemeApprovedRebateRateListConfig',
  getVictorianPatientTransportAssistanceSchemeRebateRateConfigAndResponse: 'getVictorianPatientTransportAssistanceSchemeRebateRateConfigAndResponse',
  getVptasApplicationDetailsConfigAndResponse: 'getVptasApplicationDetailsConfigAndResponse',
  getVptasApplicationConfigAndResponse: 'getVptasApplicationConfigAndResponse',
  victorianPatientTransportAssistanceSchemeApplication: 'victorianPatientTransportAssistanceSchemeApplication',
  getVptasNominatedPatientDetailsConfigAndResponse: 'getVictorianPatientTransportAssistanceSchemeNominatedPatientDetails',
  getVptasSpecialistConfig: 'getVptasSpecialistConfig',
  getVptasLgaConfigAndResponse: 'getVptasLgaConfigAndResponse',
  getVptasSpecialistProviderConfigAndResponse: 'getVptasSpecialistProviderConfigAndResponse',
  getVptasAdjustmentApplicationConfigAndResponse: 'getVptasAdjustmentApplicationConfigAndResponse',
  getApplicationSubsidyConfigAndResponse: 'getApplicationSubsidyConfigAndResponse',

};

export const API_ENDPOINTS = {
  authentication: {
    signIn: '/SignIn'
  },
  configuration: {
    default: 'FormConfiguration/GetConfiguration'
  },
  address: {
    search: 'Address/Search',
    lga: 'Address/Lga',
    calculateDistance: 'Address/CalculateDistance'
  },
  user: {
    getLoggedInUser: 'User/GetLoggedInUser',
    save: 'User/Save',
    export: 'User/ExportUsersToCsv',
    getConfigAndResponse: 'User/GetResponseAndConfig',
    isActiveUser: 'User/IsActive'
  },
  pbi: {
    embedInfo: '/PowerBI/EmbedInfo'
  },
  dashboard: {
    getUsers: 'Dashboard/GetUsers',
    getReferenceDataCategories: 'Dashboard/GetReferenceDataCategories',
    getGlStringMappings: 'Dashboard/GetGlStringMappings',
    getGlStringLookupMappingSets: 'Dashboard/GetGlStringLookupMappingSets',
    getSettings: 'Dashboard/GetSettings',
    getOrganisations: 'Dashboard/GetOrganisations',
    getCareAllowanceApplications: 'Dashboard/GetCareAllowanceApplications',
    getCareAllowancePlacements: 'Dashboard/GetCareAllowancePlacements',
    getCareAllowancePlacementRules: 'Dashboard/GetCareAllowancePlacementRules',
    getCareAllowanceFinancialYears: 'Dashboard/GetCareAllowanceFinancialYears',
    getCareAllowanceCalendarYears: 'Dashboard/GetCareAllowanceCalendarYears',
    getCareAllowanceRates: 'Dashboard/GetCareAllowanceRates',
    getCareAllowancePlacementAdjustments: 'Dashboard/GetCareAllowancePlacementAdjustments',
    getCareAllowancePlacementInvoicesByApplication: 'Dashboard/GetCareAllowancePlacementInvoicesByApplication',
    getCareAllowancePlacementInvoices: 'Dashboard/GetCareAllowancePlacementInvoices',
    getCareAllowancePlacementBulkAdHocInvoiceQueries: 'Dashboard/GetCareAllowancePlacementBulkAdHocInvoiceQueries',
    getIccmsRequestProcessingSchedules: 'Dashboard/GetIccmsRequestProcessingSchedules',
    getConcessionsApplications: 'Dashboard/GetConcessionsApplications',
    getMyConcessionsApplications: 'Dashboard/GetConcessionsApplications/MyApplications',
    getConcessionsApplicationsPendingReview: 'Dashboard/GetConcessionsApplications/PendingReview',
    getConcessionsApplicationsReadyForApproval: 'Dashboard/GetConcessionsApplications/ReadyForApproval',
    getVictorianPatientTransportAssistanceSchemeApplications: 'Dashboard/GetVictorianPatientTransportAssistanceSchemeApplications',
    getVictorianPatientTransportAssistanceSchemeMyApplications: 'Dashboard/GetVictorianPatientTransportAssistanceSchemeApplications/MyApplications',
    getVictorianPatientTransportAssistanceSchemeApplicationsPendingReview: 'Dashboard/GetVictorianPatientTransportAssistanceSchemeApplications/PendingReview',
    getVictorianPatientTransportAssistanceSchemeApplicationsReadyForApproval: 'Dashboard/GetVictorianPatientTransportAssistanceSchemeApplications/ReadyForApproval',
    getConcessionsApplicationRebateCalculationRule: 'Dashboard/GetConcessionsApplicationRebateCalculationRules',
    getPersons: 'Dashboard/GetPersons',
    getPersonsForUpdateCarer: 'Dashboard/GetPersonsForUpdateCarer',
    getPersonListForCarerApplicationUpdate: 'Dashboard/GetPersonListForCarerApplicationUpdate',
    getPersonListForPlacementApplicationUpdate: 'Dashboard/GetPersonListForPlacementApplicationUpdate',
    getPersonListForLocalAdoptionMatchCarer: 'Dashboard/GetPersonListForLocalAdoptionMatchCarer',
    getPersonListForLocalAdoptionMatchClient: 'Dashboard/GetPersonListForLocalAdoptionMatchClient',
    getVendors: 'Dashboard/GetVendors',
    getJobSchedules: 'Dashboard/GetJobSchedules',
    getJobRunLog: 'Dashboard/GetJobRunLog',
    getErrorLogs: 'Dashboard/GetErrorLogs',
    getExportedInvoices: 'Dashboard/GetExportedInvoices',
    getConcessionsInvoices: 'Dashboard/GetConcessionsInvoices',
    getConcessionsApplicationBulkUploadErrorLogs: 'Dashboard/GetConcessionsApplicationBulkUploadErrorLogs',
    getReportListConfigAndResponse: 'Dashboard/GetReportListConfigAndResponse',
    getConcessionsApplicationBulkUploads: 'Dashboard/GetConcessionsApplicationBulkUploads',
    getAgencies: 'Dashboard/GetAgencies',
    getVictorianPatientTransportAssistanceSchemeRebateRates: 'Dashboard/GetVictorianPatientTransportAssistanceSchemeRebateRates',
    getVptasApplicationSubsidies: 'Dashboard/GetVptasApplicationSubsidies',
    getVptasApplicationTripList: 'Dashboard/GetVptasApplicationTripList',
    getVptasInvoicesByApplication: 'Dashboard/GetVptasInvoicesByApplication',
    getVptasInvoicesByContact: 'Dashboard/GetVptasInvoicesByContact',
    getVptasInvoices: 'Dashboard/GetVptasInvoices',
    getVptasSpecialists: 'Dashboard/GetVptasSpecialists',
    GetVptasLgaList: 'Dashboard/GetVptasLgaList'
  },
  referenceData: {
    getConfigAndResponse: 'ReferenceData/GetResponseAndConfig',
    save: 'ReferenceData/Save',
    bulkSave: 'ReferenceData/BulkSave',    
    getOptionSetByCategory: 'ReferenceData/GetOptionSetByCategory',
    victorianPatientTransportAssistanceScheme: {
      getConfigAndResponse: 'ReferenceData/VictorianPatientTransportAssistanceScheme/GetResponseAndConfig'
    }
  },
  glStringMapping: {
    getConfigAndResponse: 'GLStringMapping/GetConfigAndResponse',
    save: 'GLStringMapping/Save',
    checkForOverlaps: 'GLStringMapping/CheckForOverlaps'
  },
  glStringLookupMappingSet: {
    getConfigAndResponse: 'GLStringLookupMappingSet/GetConfigAndResponse',
    save: 'GLStringLookupMappingSet/Save',
  },
  glStringLookupMapping: {
    getConfig: 'GLStringLookupMapping/GetConfig',
    getConfigAndResponse: 'GLStringLookupMapping/GetConfigAndResponse',
    save: 'GLStringLookupMapping/Save',
    checkForOverlaps: 'GLStringLookupMapping/CheckForOverlaps'
  },
  setting: {
    getConfigAndResponse: 'Setting/GetConfigAndResponse',
    save: 'Setting/Save',
    getSettingValueByName: 'Setting/GetSettingValueByName'
  },
  jobSchedule: {
    getConfigAndResponse: 'JobSchedule/GetConfigAndResponse',
    save: 'JobSchedule/Save',
    delete: 'JobSchedule/Delete',
  },
  job:
  {
    runAdHoc: 'Job/RunAdHoc',
    kill: 'Job/Kill',
    getInvoices: 'Job/GetInvoices',
    getErrors: 'Job/GetErrors',
    getInformation: 'Job/GetInformation',
  },
  concessionsBulkUploadJob: {
    runConcessionsBulkUploadJob: 'ConcessionsBulkUploadJob/RunConcessionsBulkUploadJob'
  },
  organisation: {
    getPrincipalCouncilDetails: 'Organisation/GetPrincipalCouncilDetails',
    getConfigAndResponse: 'Organisation/GetResponseAndConfig',
    getCouncilConfigConfigAndResponse: 'Organisation/GetResponseAndConfigForCouncilConfig',
    save: 'Organisation/Save',
    saveCouncilConfig: 'Organisation/SaveCouncilConfig'
  },
  applicationDetailCreateUpdateCarer: {
    getConfigAndResponse: 'CreateUpdateCarerApplication/GetConfigAndResponse',
    assignApplicationUser: 'CreateUpdateCarerApplication/AssignApplicationUser',
    acceptApplication: 'CreateUpdateCarerApplication/AcceptApplication',
    updatePersonWithCarerDetails: 'CreateUpdateCarerApplication/UpdatePersonWithCarerDetails',
    getVmgEmailTemplateConfigAndResponse: 'CreateUpdateCarerApplication/GetVmgEmailTemplateConfigAndResponse',
    rejectApplication: 'CreateUpdateCarerApplication/RejectApplication',
    saveVmgEmailTemplate: 'CreateUpdateCarerApplication/SaveVmgEmailTemplate',
    updateCreateCarerApplication: 'CreateUpdateCarerApplication/UpdateCreateCarerApplication',
  },
  applicationDetailCreateUpdatePlacement: {
    getConfigAndResponse: 'CreateUpdatePlacementApplication/GetConfigAndResponse',
    assignApplicationUser: 'CreateUpdatePlacementApplication/AssignApplicationUser',
    createClient: 'CreateUpdatePlacementApplication/CreateClient',
    updateCreatePlacementApplication: 'CreateUpdatePlacementApplication/UpdateCreatePlacementApplication',
    acceptApplication: 'CreateUpdatePlacementApplication/AcceptApplication',
    rejectApplication: 'CreateUpdatePlacementApplication/RejectApplication',
  },
  note: {
    save: 'Note/Save'
  },
  paymentRule: {
    getConfigAndResponse: 'PaymentRule/GetResponseAndConfig',
    save: 'PaymentRule/Save',
  },
  careAllowancePlacementRule: {
    getConfigAndResponse: 'CareAllowancePlacementRule/GetConfigAndResponse',
    save: 'CareAllowancePlacementRule/Save'
  },
  careAllowanceFinancialYear: {
    getListConfig: 'CareAllowanceFinancialYear/GetListConfig',
    getConfig: 'CareAllowanceFinancialYear/GetConfig',
    getConfigAndResponse: 'CareAllowanceFinancialYear/GetConfigAndResponse',
    getConfigAndResponseGenerateInvoicePeriods: 'CareAllowanceFinancialYear/GetConfigAndResponseGenerateInvoicePeriods',
    save: 'CareAllowanceFinancialYear/Save',
  },
  careAllowanceCalendarYear: {
    getListConfig: 'CareAllowanceCalendarYear/GetListConfig',
    getConfig: 'CareAllowanceCalendarYear/GetConfig',
    getConfigAndResponse: 'CareAllowanceCalendarYear/GetConfigAndResponse',
    getConfigAndResponseGenerateInvoicePeriods: 'CareAllowanceCalendarYear/GetConfigAndResponseGenerateInvoicePeriods',
    save: 'CareAllowanceCalendarYear/Save',
  },
  careAllowanceInvoicePeriod: {
    getConfigAndResponse: 'CareAllowanceInvoicePeriod/GetConfigAndResponse',
    save: 'CareAllowanceInvoicePeriod/Save',
  },
  careAllowanceRate: {
    getApprovedRateListConfig: 'CareAllowanceRate/GetApprovedRateListConfig',
    getPendingRateListConfig: 'CareAllowanceRate/GetPendingRateListConfig',
    export: 'CareAllowanceRate/ExportToCsv',
    getConfigAndResponse: 'CareAllowanceRate/GetConfigAndResponse',
    save: 'CareAllowanceRate/Save',
    requestDelete: 'CareAllowanceRate/RequestDelete',
    approvePendingChanges: 'CareAllowanceRate/ApprovePendingChanges',
    cancelPendingChanges: 'CareAllowanceRate/CancelPendingChanges',
    getUploadTemplate: 'CareAllowanceRate/GetUploadTemplate',
    bulkSave: 'CareAllowanceRate/BulkSave',
  },
  careAllowancePlacement: {
    getConfigAndResponse: 'CareAllowancePlacement/GetConfigAndResponse',
    getLocalAdoptionConfigAndResponse: 'CareAllowancePlacement/GetLocalAdoptionConfigAndResponse',
    getNewLocalAdoptionConfigAndResponse: 'CareAllowancePlacement/GetNewLocalAdoptionConfigAndResponse',
    holdPlacement: 'CareAllowancePlacement/Hold',
    releasePlacementHold: 'CareAllowancePlacement/ReleaseHold',
    getAdjustmentInvoices: 'CareAllowancePlacement/GetAdjustmentInvoices',
    getAdjustmentOverpaymentRecoverySchedule: 'CareAllowancePlacement/GetAdjustmentOverpaymentRecoverySchedule',
    getAdjustmentLines: 'CareAllowancePlacement/GetAdjustmentLines',
    cancelInvoice: 'CareAllowancePlacement/CancelInvoice',
    bulkUpdatePlacementEndDates: 'CareAllowancePlacement/BulkUpdateEndDates',
    bulkAssign: 'CareAllowancePlacement/BulkAssign',
    saveLocalAdoption: 'CareAllowancePlacement/SaveLocalAdoption',
    ceaseLocalAdoption: 'CareAllowancePlacement/CeaseLocalAdoption',
  },
  careAllowancePlacementAdjustment: {
    getConfig: 'CareAllowancePlacementAdjustment/GetConfig',
    getConfigAndResponse: 'CareAllowancePlacementAdjustment/GetConfigAndResponse',
    getConfigAndResponseGeneratedAdjustmentLines: 'CareAllowancePlacementAdjustment/GetConfigAndResponseWithGeneratedAdjustmentLines',
    save: 'CareAllowancePlacementAdjustment/Save',
    cancel: 'CareAllowancePlacementAdjustment/Cancel',
  },
  iccmsRequestProcessingSchedule: {
    getConfigAndResponse: 'IccmsRequestProcessingSchedule/GetConfigAndResponse',
    save: 'IccmsRequestProcessingSchedule/Save',
    delete: 'IccmsRequestProcessingSchedule/Delete',
  },
  person: {
    getConfigAndResponse: 'Person/GetResponseAndConfig',
    getPersonListConfig: 'Person/GetPersonListConfig',
    getPersonListConfigForCarerApplicationUpdate: 'Person/GetPersonListConfigForCarerApplicationUpdate',
    getPersonListConfigForPlacementApplicationUpdate: 'Person/GetPersonListConfigForPlacementApplicationUpdate',
    generateLinkingCode: 'Person/GenerateLinkingCode',
    saveCentrelinkVerifiedAddress: 'Person/SaveCentrelinkVerifiedAddress',
    getPersonBankDetailResponseAndConfig: 'Person/GetPersonBankDetailResponseAndConfig',
    savePersonBankDetail: 'Person/SavePersonBankDetail',
    bulkUpdateClientInactiveDate: 'Person/BulkUpdateClientInactiveDate'
  },
  concessionApplication: {
    delete: 'ConcessionsApplication/Delete',
    centrelinkCardCheck: 'ConcessionsApplication/CentrelinkCardCheck',
    dvaCardInvoicesMatch: 'ConcessionsApplication/DvaCardInvoicesMatch',
    centrelinkCardInvoicesMatch: 'ConcessionsApplication/CentrelinkCardInvoicesMatch',
    edaCardInvoicesMatch: 'ConcessionsApplication/EdaCardInvoicesMatch',
    invoiceAmountValidation: 'ConcessionsApplication/InvoiceAmountValidation',
    verifyNewApplicantCardDetails: 'ConcessionsApplication/VerifyNewApplicantCardDetails'
  },
  vendor: {
    getConfigAndResponse: 'Vendor/GetConfigAndResponse',
    save: 'Vendor/Save',
  },
  vendorSite: {
    delete: 'VendorSite/Delete'
  },
  agency: {
    getConfig: 'ConcessionsApplicationBulkUploadAgency/GetConfig',
    getConfigAndResponse: 'ConcessionsApplicationBulkUploadAgency/GetConfigAndResponse',
    save: 'ConcessionsApplicationBulkUploadAgency/Save',
  },
  //Dashboard list
  concessionsApplication: {
    delete: 'ConcessionsApplication/Delete',
    bulkApprove: 'ConcessionsApplication/BulkApprove',
    bulkAssign: 'ConcessionsApplication/BulkAssign',
      centrelinkCardCheck: 'ConcessionsApplication/CentrelinkCardCheck',
  },
  
  concessionsApplicationDetails: {
    getConfigAndResponse: 'ConcessionsApplication/GetConfigAndResponse',
    assignApplicationUser: 'ConcessionsApplication/AssignApplicationUser',
    putApplicationOnHold: 'ConcessionsApplication/PutApplicationOnHold',
    furtherReviewRequired: 'ConcessionsApplication/FurtherReviewRequired',
    rejectApplication: 'ConcessionsApplication/RejectApplication',
    acceptApplication: 'ConcessionsApplication/AcceptApplication',
   
    verifyNewApplicantCardDetails: 'ConcessionsApplication/VerifyNewApplicantCardDetails'
    
  },
  concessionsApplicationNonMainsWater: {
    getConfigAndResponse: 'ConcessionsApplicationNonMainsWater/GetResponseAndConfig',
    save: 'ConcessionsApplicationNonMainsWater/Save'
  },
  concessionsApplicationNonMainsEnergy: {
    getConfigAndResponse: 'ConcessionsApplicationNonMainsEnergy/GetResponseAndConfig',
    save: 'ConcessionsApplicationNonMainsEnergy/Save'
  },
  concessionsApplicationNonMainsLifeSupport: {
    getConfigAndResponse: 'ConcessionsApplicationNonMainsLifeSupport/GetResponseAndConfig',
    save: 'ConcessionsApplicationNonMainsLifeSupport/Save'
  },
  concessionsApplicationNonMainsMedicalCooling: {
    getConfigAndResponse: 'ConcessionsApplicationNonMainsMedicalCooling/GetResponseAndConfig',
    save: 'ConcessionsApplicationNonMainsMedicalCooling/Save'
  },
  concessionsApplicationEdaAndPowGoldCardMunicipalRates: {
    getConfigAndResponse: 'ConcessionsApplicationEDAAndPOWGoldCardMunicipalRates/GetResponseAndConfig',
    save: 'ConcessionsApplicationEDAAndPOWGoldCardMunicipalRates/Save'
  },
  concessionsApplicationRebateCalculationRule: {
    getApprovedRebateCalculationRuleListConfig: 'PaymentRule/GetApprovedRebateCalculationRuleListConfig',
    getPendingRebateCalculationRuleListConfig: 'PaymentRule/GetPendingRebateCalculationRuleListConfig',
    export: 'PaymentRule/ExportToCsv',
    getConfigAndResponse: 'PaymentRule/GetResponseAndConfig',
    save: 'PaymentRule/Save',
    approvePendingChanges: 'PaymentRule/ApprovePendingChanges',
    cancelPendingChanges: 'PaymentRule/CancelPendingChanges'
  },
  exportedInvoice: {
    save: 'ExportedInvoice/Save',
    getConfigAndResponse: 'ExportedInvoice/GetConfigAndResponse',
  },
  concessionsApplicationBulkUpload: {
    downloadErrorLog: 'ConcessionsApplicationBulkUpload/DownloadErrorLog',
    save: 'ConcessionsApplicationBulkUpload/Save'
  },
  concessionsApplicationBulkUploadDetail: {
    getConfigAndResponse: 'ConcessionsApplicationBulkUpload/GetConfigAndResponse'
  },
  careAllowancePlacementBulkAdHocInvoiceQuery: {
    getConfigAndResponse: 'CareAllowancePlacementBulkAdHocInvoiceQuery/GetConfigAndResponse',
    save: 'CareAllowancePlacementBulkAdHocInvoiceQuery/Save',
    runQueryPlacementsLink: 'CareAllowancePlacementBulkAdHocInvoiceQuery/RunQueryPlacementsLink',
    delete: 'CareAllowancePlacementBulkAdHocInvoiceQuery/Delete',
    approvePlacementList: 'CareAllowancePlacementBulkAdHocInvoiceQuery/ApprovePlacementList',
    getPlacementList: 'CareAllowancePlacementBulkAdHocInvoiceQuery/GetPlacementList'
  },
  careAllowancePerson: {
    getConfigAndResponse: 'CareAllowancePerson/GetConfigAndResponse',
    save: 'CareAllowancePerson/Save'
  },
  victorianPatientTransportAssistanceSchemeRebateRate: {
    getApprovedRebateRateListConfig: 'VictorianPatientTransportAssistanceSchemeRate/GetApprovedRebateCalculationRuleListConfig',
    getPendingRebateRateListConfig: 'VictorianPatientTransportAssistanceSchemeRate/GetPendingRebateCalculationRuleListConfig',
    getConfigAndResponse: 'VictorianPatientTransportAssistanceSchemeRate/GetResponseAndConfig',
    save: 'VictorianPatientTransportAssistanceSchemeRate/Save',
    approvePendingChanges: 'VictorianPatientTransportAssistanceSchemeRate/ApprovePendingChanges',
    cancelPendingChanges: 'VictorianPatientTransportAssistanceSchemeRate/CancelPendingChanges'
  },
  victorianPatientTransportAssistanceSchemeApplication: {
    getConfigAndResponse: 'VictorianPatientTransportAssistanceSchemeApplication/GetResponseAndConfig',
    IsDistanceEligibleForBlockTreatment: 'VictorianPatientTransportAssistanceSchemeApplication',
    save: 'VictorianPatientTransportAssistanceSchemeApplication/Save',
    bulkApprove: 'VictorianPatientTransportAssistanceSchemeApplication/BulkApprove',
    bulkAssign: 'VictorianPatientTransportAssistanceSchemeApplication/BulkAssign',
    furtherReviewRequired: 'VictorianPatientTransportAssistanceSchemeApplication/FurtherReviewRequired',
    assignApplicationUser: 'VictorianPatientTransportAssistanceSchemeApplication/AssignApplicationUser',
    acceptApplication: 'VictorianPatientTransportAssistanceSchemeApplication/AcceptApplication',
    ineligibleApplication: 'VictorianPatientTransportAssistanceSchemeApplication/ineligibleApplication',
    getApprovedApplicationListConfig: 'VictorianPatientTransportAssistanceSchemeApplication/GetApprovedApplicationListConfig',
    getPendingApplicationListConfig: 'VictorianPatientTransportAssistanceSchemeApplication/GetPendingApplicationListConfig',
    centrelinkCardCheck: 'VictorianPatientTransportAssistanceSchemeApplication/CentrelinkCardCheck',
  },
  vptasApplicationDetails: {
    getApplicationDetailsConfigAndResponse: 'VictorianPatientTransportAssistanceSchemeApplication/GetApplicationDetailsConfigAndResponse',
    assignApplicationUser: 'VictorianPatientTransportAssistanceSchemeApplication/AssignApplicationUser',
    acceptApplication: 'VictorianPatientTransportAssistanceSchemeApplication/AcceptApplication',
    ineligibleApplication: 'VictorianPatientTransportAssistanceSchemeApplication/ineligibleApplication',
    inProgressApplication: 'VictorianPatientTransportAssistanceSchemeApplication/InProgressApplication',
    furtherReviewRequired: 'VictorianPatientTransportAssistanceSchemeApplication/FurtherReviewRequired',
    updateApplicationStatusAsInvalidDocument: 'VictorianPatientTransportAssistanceSchemeApplication/updateApplicationStatusAsInvalidDocument',
    addAdjustmentToSubsidy: 'VictorianPatientTransportAssistanceSchemeApplication/AddAdjustmentToSubsidy',
    updateTreatmentItemPaymentEligibility: 'VictorianPatientTransportAssistanceSchemeApplication/UpdateTreatmentItemPaymentEligibility',
    uploadUpdateMetadata: 'VictorianPatientTransportAssistanceSchemeApplication/UploadUpdateMetadata',
    saveSubsidy: 'VictorianPatientTransportAssistanceSchemeApplication/SaveSubsidy',
    getApplicationSubsidyConfigAndResponse: 'VictorianPatientTransportAssistanceSchemeApplication/GetSubsidyConfigAndResponse',
  },
  vptasNominatedPatient: {
    save: 'VptasNominatedPatient/Save',
    selfNominate: 'VptasNominatedPatient/SelfNominate',
    getConfigAndResponse: 'VptasNominatedPatient/GetConfigAndResponse',
    delete: 'VptasNominatedPatient/Delete',
    updatePatientContribution: 'VptasNominatedPatient/UpdatePatientContribution'
  },
  vptasApplication: {
    cancelInvoice: 'VictorianPatientTransportAssistanceSchemeApplication/CancelInvoice',
    delete: 'VictorianPatientTransportAssistanceSchemeApplication/Delete',
  },
  vptasSpecialist: {
    getConfigAndResponse: 'VptasSpecialist/GetConfigAndResponse',
    save: 'VptasSpecialist/Save',
    saveProviderInformation: 'VptasSpecialist/SaveProviderInformation',
    delete: 'VptasSpecialist/Delete',
    getProviderConfigAndResponse: 'VptasSpecialist/GetProviderConfigAndResponse'
  },
  vptasLga: {
    getConfigAndResponse: 'VptasLga/GetConfigAndResponse',
    save: 'VptasLga/Save',
    delete: 'VptasLga/Delete',
  },
  vptasAdjustmentApplication: {
    getConfigAndResponse: 'VptasAdjustmentApplication/GetResponseAndConfig',
    save: 'VptasAdjustmentApplication/Save'
  }
};
